module.exports = __webpack_public_path__ + "media/images/amanata-438be6f34af6e099a7f7208aaa4ec4d0.jpg";